import "@/style/auth/forgotpassword.css";
import { NavLink, useNavigate } from "react-router-dom";

import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { useState } from "react";
import { SuccessNotify, FailedNotify } from "@/constants/tostify";
import Spinner from "react-bootstrap/Spinner";
import { useVerifyEmailMutation } from "@/hooks/auth/userApi";


const Verification = () => {
  const navigate = useNavigate();
  const [handlecode, setHandlecode] = useState(false);
  const email = localStorage.getItem("useremail");
  const resultemail = JSON.parse(email);
  const [getotp, setGetotp] = useState({ one1: "" });

  const [verifyEmail] = useVerifyEmailMutation();

  const handleOtp = async () => {
    setHandlecode(true);
    try {
      const res = await verifyEmail({ otp: getotp.one1, email: resultemail }).unwrap();
      if (res && res.success) {
        setHandlecode(false);
        SuccessNotify("OTP match Successfully");
        navigate("/reset");
      } else {
        setHandlecode(false);
        FailedNotify(res?.message || "Invalid verification code");
      }
    } catch (err) {
      setHandlecode(false);
      const message = err?.data?.message || err?.error || err?.message || 'Verification failed';
      FailedNotify(message);
    }
  };
  return (
    <>
      <Container fluid className="f-bg-color">
        <Row>
          <Col lg="6" className="mx-auto  background-white f-modal-style">
            <div className="ps-5 pe-5">
              <h5 className="text-center">Forgot password</h5>
              <p className="text-center mt-2 font-ss">
                Enter the code from the email or <br></br> phone number we just
                send you
              </p>

              <Form>
                <Form.Group className="mb-3" controlId="formBasicEmail">
                  <Form.Label className="labelSize">
                    Verification Code*
                  </Form.Label>
                  <Form.Control
                    type="number"
                    placeholder="Enter Code"
                    className="p-3 input-style"
                    name="one1"
                    onChange={(e) =>
                      setGetotp({ ...getotp, [e.target.name]: e.target.value })
                    }
                  />
                </Form.Group>{" "}
                <Button
                  type="button"
                  className=" bg-blue  w-100 mt-2 next-btn-s b-radius p-2"
                  onClick={handleOtp}
                >
               {handlecode === true ? (
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />
                  ) : (
                    "NEXT"
                  )}
                </Button>
                <div className="font-blue text-center  mt-lg-3 mt-xl-3 ">
                  <NavLink to="/forgot">
                    Back to Previous
                    <span style={{ color: "black" }}> page</span>
                  </NavLink>
                </div>
              </Form>
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default Verification;
